class AnnouncementBarController extends HTMLElement {
  connectedCallback() {
    this.sticky = this.getAttribute('data-sticky') === 'true';
    this.closable = this.getAttribute('data-closable') === 'true';
    this.closeBehavior = this.getAttribute('data-close-behavior');
    const closeId = this.getAttribute('data-close-id');
    this.storageKey = closeId ? `announcement-timer-bar-closed-${closeId}` : null;

    // position: sticky only sticks within its own parent's box, and Shopify renders
    // this section as its own separate wrapper div (a sibling of the header's, not
    // nested inside it) that's exactly as tall as our content. So the sticky/hidden
    // state has to live on that wrapper, not on this custom element itself.
    this.wrapper = this.closest('.announcement-timer-bar-section');

    if (this.closable && this.closeBehavior === 'session' && this.storageKey && this.wasClosed()) {
      this.remove();
      return;
    }

    if (this.sticky && this.wrapper) {
      this.updateHeight();
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.resizeObserver.observe(this);

      this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.onScroll();
    }

    if (this.closable) {
      this.closeButton = this.querySelector('[data-announcement-close]');
      this.closeButton?.addEventListener('click', this.close.bind(this));
    }
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    if (this.onScrollHandler) window.removeEventListener('scroll', this.onScrollHandler);
    document.documentElement.style.removeProperty('--announcement-timer-bar-height');
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop <= this.barHeight) {
      // Near the top of the page: no special positioning at all, same as a plain element.
      this.wrapper.classList.remove('announcement-timer-bar-section--stuck', 'announcement-timer-bar-section--hidden');
    } else if (scrollTop > this.lastScrollTop) {
      // Scrolling down past the bar's own height: stick, then hide.
      this.wrapper.classList.add('announcement-timer-bar-section--stuck', 'announcement-timer-bar-section--hidden');
    } else if (scrollTop < this.lastScrollTop) {
      // Scrolling up: stick and reveal.
      this.wrapper.classList.add('announcement-timer-bar-section--stuck');
      this.wrapper.classList.remove('announcement-timer-bar-section--hidden');
    }

    this.lastScrollTop = scrollTop;
  }

  wasClosed() {
    try {
      return sessionStorage.getItem(this.storageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  close() {
    if (this.closeBehavior === 'session' && this.storageKey) {
      try {
        sessionStorage.setItem(this.storageKey, 'true');
      } catch (error) {
        /* sessionStorage unavailable, fall back to closing for this view only */
      }
    }

    this.remove();
    document.documentElement.style.removeProperty('--announcement-timer-bar-height');
  }

  updateHeight() {
    this.barHeight = this.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--announcement-timer-bar-height', `${this.barHeight}px`);
  }
}

customElements.define('announcement-bar-controller', AnnouncementBarController);
